import React from "react";
import ViewSDKClient from "./ViewSdkClient";

const RenderMenu = ({ url, applicantId, token, agencyKey, fileName }) => {
    const loadPDF = () => {
        const viewSDKClient = new ViewSDKClient();

        viewSDKClient.ready().then(() => {

            const options = {
                defaultViewMode: "FIT_WIDTH",
                showAnnotationTools: false,
                showLeftHandPanel: false,
                showPageControls: false,
                showDownloadPDF: true,
                showPrintPDF: true,
                showDisabledSaveButton: true
            }
            
            viewSDKClient.previewFile("pdf-div", options, url, fileName, applicantId, token, agencyKey);

            viewSDKClient.registerSaveApiHandler(applicantId, token, agencyKey);
        });
    };

    return (
        <div className="mt-28">
            <div
                id="pdf-div"
                className="full-window-div border border-gray-100 h-screen"
                style={{ height: "1000px", textAlign: "center" }}
                onLoad={loadPDF()}
            ></div>
        </div>
    );
};
export default RenderMenu;


// WEBPACK FOOTER //
// ./src/common/PdfRenderMenu.js